<template>
  <div class="body-container">
      <div>
        <div class="flex-wrap text-center text-box p-2">
          <span class="text-content">Enter your mobile number to create your profile and start playing!</span>
        </div>
        <div class="flex-wrap text-center text-box p-2 pt-1">
          <input type="text" v-model="msisdn" v-on:change="msisdnConversion" class="text-content msisdn-input"
                 placeholder="CELLPHONE NUMBER" required/>
        </div>
        <div class="flex-wrap text-center text-box" v-if="!validMsisdn">
          <span class="text-content error-message">Please enter a valid msisdn.</span>
        </div>
        <div class="d-flex justify-content-center p-1">
          <button class="retry-button mt-0" @click="onMsisdnSubmitClicked">Continue</button>
        </div>
        <div class="flex-wrap text-center text-box p-1">
          <a href="http://play.zedgames.mobi/terms-conditions">T & C's apply.</a>
        </div>
      </div>
    </div>
</template>

<script>
import {environmentConfig} from "@/config/environmentConfig";
import ZambiaIntegrationService from "@/services/zambiaIntegrationService";

export default {
  name: "PostOptIn",
  mounted() {
    this.msisdn = this.$route.query.msisdn;
  },
  data() {
    return {
      msisdn: undefined,
      validMsisdn: true
    }
  },
  methods: {
    msisdnConversion() {
      if (this.msisdn.startsWith("0")) {
        this.msisdn = this.msisdn.slice(1);
        const zmbNumber = "260";
        this.msisdn = parseInt(zmbNumber + this.msisdn, 10);
      } else if (this.msisdn.startsWith("+")) {
        this.msisdn = this.msisdn.slice(1);
      }
    },
    async onMsisdnSubmitClicked() {
      if (this.msisdn.toString().length === 12) {
        const getUserResponse = await ZambiaIntegrationService.getUserViaMsisdn(this.msisdn);
        if (getUserResponse?.data?.Status === "SUBSCRIBED")
          window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
        else {
          window.open(`${environmentConfig.zedGamesHEHost}`, '_self');
        }
      } else {
        this.validMsisdn = false;
      }
    },
  },
}
</script>

<style scoped>

.error-message {
  color: #CE0000;
}
</style>
